export const isAbsoluteUrl = (url: string) =>
  url.startsWith("http") || url.startsWith("tel:") || url.startsWith("mailto:")
